import api from '../api/axios';

class DeudasService {
  async getDeudas() {
    const { data } = await api.get('/deudas');
    return data;
  }
  async createDeuda(data) {
    const { data: res } = await api.post('/deudas', data);
    return res;
  }
  async updateDeuda(id, data) {
    const { data: res } = await api.put(`/deudas/${id}`, data);
    return res;
  }
  async deleteDeuda(id) {
    const { data } = await api.delete(`/deudas/${id}`);
    return data;
  }
}

export default new DeudasService();
